import { atom } from "recoil";
import { FilterDef } from "../../../constants/FinanceModels";

// The state for requesting an update on EnelX's reports table
export const STATE_REPORT_UPDATING = atom<boolean>({
    key: "enelx-state-report-updating",
    default: false
});

// The state for requesting an update on EnelX's recharges table
export const STATE_RECHARGE_UPDATING = atom<boolean>({
    key: "enelx-state-recharge-updating",
    default: false
});

// The state of the active tab in EnelX page
export const STATE_ACTIVE_TAB = atom<number>({
    key: 'enelx-state-active-tab',
    default: 0
});

// The state of active filters on EnelX's reports page
export const STATE_REPORT_ACTIVE_FILTERS = atom<FilterDef[]>({
    key: 'enelx-state-report-active-filters',
    default: []
});

// The state of active filters on EnelX's recharges page
export const STATE_RECHARGE_ACTIVE_FILTERS = atom<FilterDef[]>({
    key: 'enelx-state-recharge-active-filters',
    default: []
});

// The state of active filters on EnelX's configuration page
export const STATE_CONFIGURATION_FILTERS = atom<FilterDef[]>({
    key: 'enelx-state-configuration-filters',
    default: []
});


// The state of counters on EnelX's reports page
export const STATE_REPORT_TOTAL_COUNT = atom<any>({
    key: 'enelx-state-report-total-count',
    default: null
});

export const STATE_RECHARGE_TOTAL_COUNT = atom<number>({
    key: 'enelx-state-recharge-total-count',
    default: 0
});

// The state of file uploading on EnelX's reports page
// The state for requesting an update on EnelX's reports table
export const STATE_REPORT_UPLOADING = atom<File | undefined>({
    key: "enelx-state-report-uploading",
    default: undefined
});

export const STATE_DISABLE_TAB = atom<boolean>({
    key: "enelx-state-tab-disable",
    default: false
});